import { Alert, AlertProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

const AlertHearingAidEvaluationAlreadyScheduled = (props: AlertProps) => {
  const { t } = useTranslation()
  return (
    <Alert {...props} severity="warning">
      {t('pages.appointment.messages.initialAppointmentAlreadyBooked')}
    </Alert>
  )
}

export { AlertHearingAidEvaluationAlreadyScheduled }
